var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddLightGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9C0 4.032 4.032 0 9 0C13.968 0 18 4.032 18 9C18 13.968 13.968 18 9 18C4.032 18 0 13.968 0 9ZM9.9 9.9H12.6C13.095 9.9 13.5 9.495 13.5 9C13.5 8.505 13.095 8.1 12.6 8.1H9.9V5.4C9.9 4.905 9.495 4.5 9 4.5C8.505 4.5 8.1 4.905 8.1 5.4V8.1H5.4C4.905 8.1 4.5 8.505 4.5 9C4.5 9.495 4.905 9.9 5.4 9.9H8.1V12.6C8.1 13.095 8.505 13.5 9 13.5C9.495 13.5 9.9 13.095 9.9 12.6V9.9Z",
    fill: "#B9C1C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddLightGrey);
export default __webpack_public_path__ + "static/media/add-light-grey.ee8eb754a6b1aa76a1d40bc742ad4eb3.svg";
export { ForwardRef as ReactComponent };